export default __webpack_public_path__ + "static/media/pisces.7fb196a1.png";